const { __ } = wp.i18n;

/**
 * Takes the result image data from the api reponse,
 * handles it and appends it to the relevant quiz using the "element", which is the passed results element
 *
 * @param {Object} resultImage - The results image object containing url, width, height etc
 * @param {Object} element - The results element on the front end which will contain the image
 *
 */
export const resultImageHelper = (resultImage) => {
	let url = '';
	let id = '';
	let alt = '';

	// Create an array from resultImage object
	const imgAttributes = Object.keys(resultImage);

	// Conditional to check image exists and array is popluated before output the element
	if (imgAttributes.length > 0) {
		// Loop over array and set each item as an attribute
		imgAttributes.forEach((key) => {
			// If key = url set the variable
			if (key === 'url') {
				url = resultImage[key];
			}
			// If key = url set the variable
			if (key === 'id') {
				id = resultImage[key];
			}
			// If key = url set the variable
			if (key === 'alt') {
				alt = resultImage[key];
			}
		});
	}
	return {
		url,
		id,
		alt,
	};
};

/**
 * Copies the page URL to the users clipboard and displays an alert.
 * @returns {void}
 */
export const copyURLToClipboard = (event) => {
	event.preventDefault();

	// Create a share URL that strips all params and adds '?shared'.
	const currentHref = window.location.href;
	const currentUrl = new URL(currentHref);
	const shareUrl = `${currentUrl.origin}${currentUrl.pathname}?shared`;

	navigator.clipboard.writeText(shareUrl).then(() => {
		// Alert user if on desktop.
		if (window.innerWidth >= 1024) {
			const alert = document.querySelector('.mavisQuiz_shareAlert');
			const button = document.querySelector('.mavisQuiz_shareAlert-close');

			// Show alert & focus onto 'close' button for easy keyboard use.
			alert.classList.remove('is-hidden');
			button.focus();

			// On either click or when 'enter' is pressed, hide the alert again.
			button.addEventListener('click', (e) => {
				e.preventDefault();
				alert.classList.add('is-hidden');
			});
			button.addEventListener('keydown', (e) => {
				e.preventDefault();
				if (e.keyCode === 13) {
					alert.classList.add('is-hidden');
				}
			});
		}
	});
};

/**
 * Alert box when the user shares a quiz with friends.
 */
export const quizAlert = `
<div class="mavisQuiz_shareAlert is-hidden">
	<p>${__(
		'The link to this page has been copied to your clipboard so you can share it with your friends',
		'mavis',
	)}</p>
	<button class="mavisQuiz_shareAlert-close">${__('close', 'mavis')}</button>
</div>`;

/**
 * Checks if the dataLayer exists on the window and pushes the data if it can.
 * @param {object} obj - Object of data to push to datalayer.
 */
export const dataLayerPush = (obj) => {
	if (window.dataLayer) {
		window.dataLayer.push(obj);
	}
};
